"use client";

import { createContext, useContext, useMemo } from "react";
import { useSmartImportTaskPolling } from "./useSmartImportTaskPolling";
import { BackendImportTasksOutput } from "@/src/types/api/smartUpload";
const AppNotificationContext = createContext<{
  smartImportTaskPolling: {
    setCachedLatestTask: (task: BackendImportTasksOutput | undefined) => void;
    pollSmartImportTask: () => void;
  };
} | null>(null);
export function AppNotificationProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pollSmartImportTask,
    setCachedLatestTask
  } = useSmartImportTaskPolling();
  const contextValue = useMemo(() => ({
    smartImportTaskPolling: {
      setCachedLatestTask,
      pollSmartImportTask
    }
  }), [pollSmartImportTask]);
  return <AppNotificationContext.Provider value={contextValue} data-sentry-element="unknown" data-sentry-component="AppNotificationProvider" data-sentry-source-file="AppNotificationContext.tsx">
      {children}
    </AppNotificationContext.Provider>;
}
export const useAppNotificationContext = () => {
  const context = useContext(AppNotificationContext);
  if (!context) {
    throw new Error("useAppNotificationContext must be used within a AppNotificationController");
  }
  return context;
};